import { Dispatch, ReactNode, SetStateAction, useState } from 'react'

import { AssociationsModal, HelperWrapper, InviteScannerModal } from 'src/components'
import { IAccountScannerRespDto } from 'src/types'

import useStyles from 'src/components/associations/styles'
import { ConnectionsList } from './connections-list.component'
import { ScannersModal } from 'src/components/associations-modal/scanners-modal.component'

interface Props {
  description: string | ReactNode
  selectedItems: string[]
  setSelectedItems: Dispatch<SetStateAction<string[]>> | ((value: string[]) => void)
  handleSelectItem: (value: string) => void
  isRound?: boolean
  connections: IAccountScannerRespDto[]
  isDisabled?: boolean
}

const ScannersAssociations = ({
  description,
  isRound,
  selectedItems,
  handleSelectItem,
  connections,
  isDisabled,
}: Props) => {
  const classes = useStyles({ isRoundImage: isRound })

  const [open, setOpen] = useState(false)
  const handleOpenModal = () => setOpen(true)
  const handleCloseModal = () => setOpen(false)

  const [inviteOpen, setInviteOpen] = useState(false)
  const handleInviteOpen = () => setInviteOpen(true)
  const handleInviteClose = () => setInviteOpen(false)

  const selectionCount = selectedItems ? selectedItems.length : 0

  return (
    <>
      <div className={classes.bigContainer}>
        <div className={classes.text}>{description}</div>
        <div className={classes.textCounter}>
          {selectionCount}&nbsp;
          <HelperWrapper t="scanners-header-title" />
        </div>
        <ConnectionsList
          items={connections}
          handleSelectItem={handleSelectItem}
          isDisabled={isDisabled}
        />
        <>
          <AssociationsModal
            modalContentNode={
              <ScannersModal
                handleInviteOpen={handleInviteOpen}
                handleClose={handleCloseModal}
                handleSelectItem={handleSelectItem}
                selectedItems={selectedItems}
              />
            }
            open={open}
            handleCloseModal={handleCloseModal}
          />
        </>
        <input
          width={'100%'}
          name="image"
          accept="image/*"
          id={`scanners-connection`}
          type="checkbox"
          multiple
          hidden
          onChange={handleOpenModal}
        />
      </div>
      <InviteScannerModal
        handleSelectItem={handleSelectItem}
        open={inviteOpen}
        handleClose={handleInviteClose}
      />
    </>
  )
}

export { ScannersAssociations }
